import React, { useReducer } from "react";
import { defaultTablePerPageCount } from "../preference-helpers/defaultTablePreferenceData";

type PaginationAndSortProps = {
  pageNo: number;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  perPageCount: number;
  searchQuery?: string | null;
};

type ActionProps = {
  type: "setSortColumn" | "setPageNo" | "setPerPageCount" | "setSearchQuery";
  payload: any;
};
const reducerFunction = (
  state: PaginationAndSortProps,
  action: ActionProps,
) => {
  switch (action.type) {
    case "setSortColumn":
      if (action.payload === state.sortColumn) {
        return {
          ...state,
          sortDirection:
            state.sortDirection === "asc" ? "desc" : ("asc" as "asc" | "desc"),
          sortColumn: action.payload,
        };
      }
      return {
        ...state,
        sortDirection: "asc" as "asc" | "desc",
        sortColumn: action.payload,
      };

    case "setPageNo":
      return {
        ...state,
        pageNo: action.payload,
      };
    case "setPerPageCount":
      return {
        ...state,
        perPageCount: action.payload,
      };
    case "setSearchQuery":
      return {
        ...state,
        searchQuery: action.payload,
      };
    default:
      return { ...state };
  }
};
export const usePaginationAndSort = (
  initialValue?: Partial<PaginationAndSortProps>,
): [PaginationAndSortProps, React.Dispatch<ActionProps>] => {
  const [state, dispatch] = useReducer(reducerFunction, {
    pageNo: initialValue?.pageNo || 1,
    sortColumn: initialValue?.sortColumn || "created_at",
    sortDirection: initialValue?.sortDirection || "desc",
    perPageCount: initialValue?.perPageCount || defaultTablePerPageCount,
    searchQuery: initialValue?.searchQuery || null,
  });

  return [
    {
      pageNo: state.pageNo,
      perPageCount: state.perPageCount,
      sortColumn: state.sortColumn,
      sortDirection: state.sortDirection,
      searchQuery: state.searchQuery,
    },
    dispatch,
  ];
};
